/** Central keys to avoid typos and keep reads/writes aligned. */
export const LOCAL_STORAGE_KEYS = {
  SUPPORT_MODAL_SEEN: 'is-support-modal-seen',
  COMMISSION_BANNER_LAST_DISMISSED_DATE: 'commission-banner-last-dismissed-date',
} as const;

function getStorage(): Storage | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function getLocalStorageItem(key: string): string | null {
  return getStorage()?.getItem(key) ?? null;
}

export function setLocalStorageItem(key: string, value: string): void {
  try {
    getStorage()?.setItem(key, value);
  } catch {
    // quota, private mode, or disabled storage
  }
}

export function getLocalStorageBoolean(key: string): boolean {
  return getLocalStorageItem(key) === 'true';
}

export function setLocalStorageBoolean(key: string, value: boolean): void {
  setLocalStorageItem(key, value ? 'true' : 'false');
}
